export default __webpack_public_path__ + "static/media/sounds/rct_accuracy_practice_incorrect_1.mp3";